<template>
  <div class="user">
    <CreateOrEditUser
      ref="createOrEditDialog"
      :roleList="roleList"
      @submitDialog="GetTableList"
    />

    <CreateOrEditTenant ref="createOrEditTenant" @submitDialog="GetTableList" />

    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>后管用户</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="HeaderButtons">
        <el-button
          v-if="$store.getters.checkPermission('admin_user.add')"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="CreateItem({ is_backend: 1 })"
          >{{ l("新增") }}</el-button
        >
      </div>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="3">
          <label>昵称</label>
          <el-input
            :placeholder="l('请输入') + l('内容')"
            v-model="SearchData.name"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <label>账号</label>
          <el-input
            :placeholder="l('请输入') + l('内容')"
            v-model="SearchData.mobile"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <label>角色</label>
          <el-select
            clearable
            v-model="customSearchData.role_3"
            @change="GetTableList(true)"
          >
            <el-option
              v-for="item of roleList.filter((item) => item.type == 3)"
              :key="item.id"
              :label="item.display_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            @click="GetTableList(true)"
            >{{ l("查询") }}</el-button
          >
        </el-col>
      </el-row>

      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <TableOperation
          :operationList="[
            {
              is_show: (row) =>
                this.$store.getters.checkPermission('admin_user.edit'),
              label: l('详情'),
              command: 'ViewItem',
            },
            {
              is_show: (row) => row.status == 1 && row.id != $store.state.session.user.id,
              label: '模拟登录',
              command: 'simulate',
            },
            {
              is_show: (row) =>
                this.$store.getters.checkPermission('admin_user.edit') &&
                row.status == 1,
              label: '冻结账号',
              command: 'disableItem',
            },
            {
              is_show: (row) =>
                this.$store.getters.checkPermission('admin_user.edit') &&
                row.status == 0,
              label: '解冻账号',
              command: 'enableItem',
            },
          ]"
          @handleOperation="HandleOperation"
        />

        <el-table-column
          prop="mobile"
          label="手机号"
          width="120"
          fixed
        ></el-table-column>
        <el-table-column label="头像" width="100">
          <template slot-scope="scope">
            <div class="ImageInTable">
              <el-image
                v-if="scope.row.avatar"
                :src="scope.row.avatar"
                fit="contain"
                :preview-src-list="[scope.row.avatar]"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="display_name"
          label="昵称"
          width="100"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column label="角色" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getRole(3, scope.row) }}
          </template>
        </el-table-column>

        <el-table-column :label="l('状态')" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 1" class="color-success">正常</div>
            <div v-else class="color-danger">冻结</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="created_time"
          :label="l('创建时间')"
          sortable="custom"
          width="170"
        ></el-table-column>

        <el-table-column
          prop="last_visit_time"
          label="上次访问"
          width="170"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditUser from "./operation/CreateOrEditUser.vue";
import CreateOrEditTenant from "@/views/admin_tenant/operation/CreateOrEditTenant.vue";

export default {
  name: "BackendUser",
  components: {
    CreateOrEditUser,
    CreateOrEditTenant,
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        name: "",
        mobile: "",
        tenant_id: "",
        source: "",
      },
      customSearchData: {
        role_1: "",
        role_2: "",
        role_3: "",
      },
      roleList: [],

      showJoinDialog: false,
      join_tenant_id: "",
      join_user_id: "",
    };
  },
  created() {
    this.SearchData.tenant_id = this.$route.query.tenant_id;
    this.axios
      .get("/api/role/", {
        params: {
          // type: 3, //1注册用户 2前台 3后管
        },
      })
      .then((data) => {
        this.roleList = data;
      });
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      var role_list = [];
      if (this.customSearchData.role_1)
        role_list.push(this.customSearchData.role_1);
      if (this.customSearchData.role_2)
        role_list.push(this.customSearchData.role_2);
      if (this.customSearchData.role_3)
        role_list.push(this.customSearchData.role_3);

      this.axios
        .get("/api/admin_user/", {
          params: {
            ...this.SearchData,
            is_backend: 1,
            role: role_list.join(","),
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    enableItem(item) {
      this.$confirm(`是否解冻用户【${item.mobile}】`, "", {
        type: "warning",
      }).then(() => {
        this.axios.put(`/api/admin_user/${item.id}/enable/`).then(() => {
          this.GetTableList();
        });
      });
    },
    disableItem(item) {
      this.$confirm(
        "冻结后该用户将无法登录平台",
        `冻结用户【${item.mobile}】`,
        {
          type: "warning",
        }
      ).then(() => {
        this.axios.put(`/api/admin_user/${item.id}/disable/`).then(() => {
          this.GetTableList();
        });
      });
    },
    getRole(type, row) {
      for (var role_id of row.role_list) {
        for (var role of this.roleList.filter((role) => role.type == type)) {
          if (role.id == role_id) {
            return role.display_name;
          }
        }
      }
    },
    viewTenant(item) {
      this.$refs.createOrEditTenant.Type = "View";
      this.$refs.createOrEditTenant.Show({ id: item.tenant_id });
    },
    simulate(item) {
      if (this.$store.state.session.host_token) {
        this.$message.error("已处于模拟登录状态，请勿重复操作");
        return;
      }

      this.axios
        .post("/api/simulate_login/", { user_id: item.id })
        .then((response) => {
          var old_token = this.$localStorage.get("token");
          this.$localStorage.set("host_token", old_token);
          this.$store.setSession("host_token", old_token);

          if(this.$store.getters.checkRole(3001)||this.$store.getters.checkRole(3002)){
            this.$localStorage.set("host_token_admin", 1);
            this.$store.setSession("host_token_admin", 1);
          } else {
            this.$localStorage.set("host_token_admin", 2);
            this.$store.setSession("host_token_admin", 2);
          }

          this.$localStorage.set("token", response);
          this.$store.setSession("token", response);
          setTimeout(() => {
            //保证在finally之后执行
            this.$store.dispatch("updateSession").then(() => {
              this.$store.commit("updateUnreadNotify");
              this.$router.push({ path: "/" });
            });
          });
        });
    },
    join() {
      this.axios
        .put(`/api/admin_user/${this.join_user_id}/join_sub/`, {
          tenant_id: this.join_tenant_id,
        })
        .then(() => {
          this.showJoinDialog = false;
          this.GetTableList();
        });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

